import ResponsiveImage from '~/components/Image/ResponsiveImage'

interface PuzzlePieceProps {
  size?: number
}

const PuzzlePiece = ({ size = 36 }: PuzzlePieceProps): React.ReactElement => {
  return (
    <ResponsiveImage
      alt="puzzle"
      height={size}
      imageClassName=""
      imageWidths={`${size * 2}`}
      srcKey="onboarding/icons/puzzle-piece-gradient-transparent-bg.png"
      width={size}
    />
  )
}

export default PuzzlePiece
